module.exports = __webpack_public_path__ + "static/media/glass-martini-alt.aadd257e.svg";